<template>
  <div class="d-flex justify-center">
    <div
      :class="{ isSubtitle: isSubtitle }"
      class="title-row d-flex flex-column align-center"
    >
      <h1 v-if="title" class="header-title" v-html="title"></h1>
      <h1 v-if="description" class="intro" v-html="description"></h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArticleTitleRow",
  props: {
    html: {
      required: false,
      default: false,
      type: Boolean,
    },
    title: {
      required: false,
      default: "",
      type: String,
    },
    description: {
      required: false,
      default: "",
      type: String,
    },
    isSubtitle: {
      required: false,
      default: false,
      Type: Boolean,
    },
  },
};
</script>
<style lang="scss" scoped>
.title-row {
  gap: 24px;
  max-width: 928px;
  margin: 5px 0 32px 0;
  text-align: center;
  z-index: 99;
  &.isSubtitle {
    margin-top: 0 !important;
  }

  // .header-title {
  //   font-size: 28px !important;
  //   font-weight: 500 !important;
  //   line-height: 30px;
  //   letter-spacing: -1px !important;
  //   text-align: center !important;
  // }

  // .header-description {
  //   font-size: 22px !important;
  //   font-weight: 400 !important;
  //   line-height: 26px !important;
  //   text-align: center !important;
  // }
}
</style>
